export default __webpack_public_path__ + "static/media/dt-1.3af41172.webp";